/* ==========================================================================
   Herb & Heal - mobile optimisation layer (behaviour)
   Added 2026-08-11 from the mobile funnel audit.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var bar = document.getElementById('hh-sticky-bar');
    var stickyBtn = document.getElementById('hh-sticky-btn');
    var realBtn = document.getElementById('hh-atc-btn');

    if (!bar || !realBtn) return;

    /* ------------------------------------------------------------------
       FIX 2 - the sticky CTA did not add to cart.
       It ran scrollIntoView(), so a shopper who had scrolled ~5,800px of
       product page tapped "Add to Cart" and got scrolled somewhere else.
       We strip the inline handler and click the real submit button, which
       keeps the delegated submit handler and applySellingPlan() intact.
       ------------------------------------------------------------------ */
    if (stickyBtn) {
      stickyBtn.removeAttribute('onclick');
      stickyBtn.onclick = null;

      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (realBtn.disabled) return;

        stickyBtn.disabled = true;
        realBtn.click();
        setTimeout(function () { stickyBtn.disabled = false; }, 1200);
      });
    }

    /* ------------------------------------------------------------------
       Reserve space so the fixed bar stops covering the bottom of the page.
       Applied once on load rather than toggled on scroll, so it never
       causes a layout shift.
       ------------------------------------------------------------------ */
    document.body.classList.add('hh-sticky-on');

    /* ------------------------------------------------------------------
       Show/hide the bar with IntersectionObserver instead of measuring on
       every scroll event. The theme's own scroll listener calls
       getBoundingClientRect() per event, which forces a reflow each frame.
       Both toggle the same .show class, so they agree; this one simply
       does not cost a layout pass.
       ------------------------------------------------------------------ */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(realBtn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
